module.exports = "/_next/static/images/uv-desktop-33d2f76eb384b61bdfc242e84cfa43ae.jpg";